import queryString from 'query-string';
import _ from 'lodash';
import crypto from 'crypto';

export interface SerializedError {
  readonly $isError: true;
  readonly name: string;
  readonly code: string;
  readonly message: string;
  readonly stack: string;
}

export function transformErrorForSerialization(error: Error): SerializedError;
export function transformErrorForSerialization(error: any): any;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function transformErrorForSerialization(error: any): any {
  if (error instanceof Error) {
    const { name, message } = error;
    const stack: string = (<any>error).stacktrace || (<any>error).stack || '';
    return {
      $isError: true,
      name,
      code: message,
      message,
      stack,
    };
  }
  if (typeof error === 'string') {
    return {
      code: error,
      message: error,
    };
  }
  const err = _.cloneDeep(error || {});
  delete err.config;
  return err;
}

// 获取url所有参数
export function getUrlQuery(url: string): { query: any; url: string } {
  return queryString.parseUrl(url);
}

// @ts-ignore
export function getFileMd5(_readStream: fs.ReadStream | Blob): Promise<string> {
  const readStream = _readStream;
  return new Promise((resolve, reject) => {
    const md5 = crypto.createHash('md5');
    readStream.on('data', (chunk: any) => {
      md5.update(chunk);
    });
    readStream.on('error', (err: any) => {
      reject(err);
    });
    readStream.on('end', () => {
      const hash = md5.digest('hex');
      readStream.close();
      readStream.destroy();
      resolve(hash);
    });
  });
}
